import React from "react";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import InnerContactArea from "../components/Contact/InnerContactArea";
import Layout from "../layouts/Layout";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us – The Digital Creative Designs USA</title>
        <meta
          name="description"
          content="Get in touch with The Digital Creative Designs for expert design in USA. Reach out today and let us help bring your creative ideas to life!"
        />
       <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs" />
        <meta
          property="og:title"
          content="Contact Us – The Digital Creative Designs USA"
        />
        <meta
          property="og:description"
          content="Get in touch with The Digital Creative Designs for expert design in USA. Reach out today and let us help bring your creative ideas to life!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta property="og:url" content="https://thedigitalcreativedesigns.com/contact" />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo1.png"
        />

        <link rel="canonical" href="https://thedigitalcreativedesigns.com/contact" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Contact Us"}
          subtitle={"Contact"}
          className={"breadcrumb-area-four pt-175 pb-160"}
          showShape={false}
          showShapeThree={true}
        />
        <InnerContactArea />
      </Layout>
    </>
  );
};

export default ContactPage;
